import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiChatApi } from 'src/services/aiChatApi'

import { UseGetAiChatConversationQueryParams } from './interfaces/useGetAiChatConversationQuery.interface'

export const useGetAiChatConversationQuery = ({
  conversationId,
  enabled = true,
}: UseGetAiChatConversationQueryParams) => {
  return useQuery({
    enabled: !!conversationId && enabled,
    queryFn: () => AiChatApi.getConversation(conversationId!),
    queryKey: [QueryKey.GET_AI_CHAT_CONVERSATION, conversationId],
  })
}
